import classNames from 'classnames'

import { commonIcons } from '@apps-common/config/icons'

interface IProps {
  title?: string
  message: string
  disabled: boolean
  callback: () => void
  classes1?: string
  classes2?: string
  classes3?: string
}

export const NoResultsAddCard: React.FC<IProps> = ({ title, message, disabled, callback, classes1, classes2, classes3 }) => {
  const AddIcon = commonIcons.add

  return (
    <button
      type='button'
      className={classNames(
        'relative w-full bg-surface text-text border border-border rounded-[25px] flex items-center justify-between gap-[5px] sm:gap-[15px] p-[7.5px]',
        classes1,
        disabled && 'cursor-not-allowed'
      )}
      disabled={disabled}
      onClick={() => {
        if (!disabled) {
          callback()
        }
      }}
    >
      <div className='leading-[1.5em] text-left pl-[1rem]'>
        <p className='jost-bold text-[0.95em]'>{title || 'No results'}</p>
        <p className='jost text-[0.8em] sm:text-[0.9em]'>{message}</p>
      </div>
      <div className={classNames('flex', disabled && 'opacity-40')}>
        <div
          className={classNames(
            'flex flex-col items-center justify-between gap-[5px] bg-surface-2 px-4 py-2 rounded-3xl border border-border',
            classes2
          )}
        >
          <div className={classNames('relative bg-surface w-[35px] h-[35px] rounded-[17.5px] flex items-center justify-center', classes3)}>
            <AddIcon className='text-[1.35rem]' />
          </div>
          <p className='jost-light text-[0.85em]'>Add</p>
        </div>
      </div>
    </button>
  )
}
